/**
 * @param {HTMLElement} element
 * @param {CSSStyleDeclaration} [style]
 * @returns {boolean}
 */
export function isHidden(element, style = undefined) {
  if (style) {
    return style.display === 'none';
  }

  return element.offsetParent === null;
}

/**
 * @param {string} tagName
 * @param {object} [options]
 * @returns {HTMLElement}
 */
export function createElement(tagName, options = {}) {
  const element = document.createElement(tagName);

  for (const [key, value] of Object.entries(options)) {
    if (key === 'class') {
      element.classList.add(...Array.isArray(value) ? value : [value]);
    } else if (key === 'text') {
      element.textContent = value;
    } else if (key === 'html') {
      element.innerHTML = value;
    } else if (key === 'dataset') {
      for (const [dataKey, dataValue] of Object.entries(value)) {
        element.dataset[dataKey] = dataValue;
      }
    } else {
      element.setAttribute(key, value);
    }
  }

  return element;
}

/**
 * @param {string} value
 * @returns {Document}
 */
export function parseHtml(value) {
  return (new DOMParser()).parseFromString(value, 'text/html');
}

/**
 * @param {?string} id
 * @param {Document} [context]
 * @returns {?HTMLElement}
 */
export function idref(id, context = document) {
  return id !== null ? context.getElementById(id) : null;
}

/**
 * @param {string} selector
 * @param {HTMLElement|Document} [context]
 * @returns {?HTMLElement}
 */
export function qs(selector, context = document) {
  return context.querySelector(selector);
}

/**
 * @param {string} selector
 * @param {HTMLElement|Document} [context]
 * @returns {HTMLElement[]}
 */
export function qsa(selector, context = document) {
  return Array.from(context.querySelectorAll(selector));
}

/**
 * Get the width of the element including the padding and border-width.
 *
 * @param {?HTMLElement} element
 * @returns {number}
 */
export function width(element) {
  return element?.getBoundingClientRect().width ?? 0;
}

/**
 * Get the height of the element including the padding and border-width.
 *
 * @param {?HTMLElement} element
 * @returns {number}
 */
export function height(element) {
  return element?.getBoundingClientRect().height ?? 0;
}

/**
 * @type {number}
 */
let idCounter = 0;

/**
 * Generate a unique id for an element.
 *
 * @param {string} [prefix]
 * @returns {string}
 */
export function uniqueId(prefix = '') {
  return String(prefix) + (++idCounter);
}